// extracted by mini-css-extract-plugin
export default {"list":"TabList__list___Hy93q","tab":"TabList__tab___vr4aa"};